const _CONFIG = {
  VERSION: "1.10",
  AUTHOR: "Taichi Murakami"
}

export default _CONFIG;